import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { ObstetricalFileResourcesEdinburghPostnatalDepressionScale } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalFileResourcesEdinburghPostnatalDepressionScale";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileResourcesEdinburghScale extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const edinburghScale = this.props.form.Resources;

        return (
            <div className="section">
                <ObstetricalFileResourcesEdinburghPostnatalDepressionScale<BritishColumbiaObstetricalFileForm>
                    {...this.props}
                    model={edinburghScale.PostnatalDepressionScale}
                    mutatePostnatalDepressionScaleWithFormUpdate={mutation =>
                        this.props.mutateModelStateWithFormUpdate(s => {
                            let shouldUpdateSection14 = this.shouldUpdateSection14();

                            mutation(s.Resources.PostnatalDepressionScale);
                            if (shouldUpdateSection14)
                                this.autoFillSection14(s);
                        })
                    }
                    outerClassName="padding-xs-left padding-xs-right"
                />
                <div className="row margin-md-top">
                    <div className="display-flex-justified-end flex-col-gap-xl padding-sm-bottom">
                        {this.renderScore(
                            this.renderMultipleLabel(
                                "ObstetricalFile_SelfHarmSubscoreLabel",
                                null,
                                this.getLabelSuffix(
                                    `(${this.getString("ObstetricalFile_QuestionAbbrev10Label")}):`,
                                    "text-bold"
                                )
                            ),
                            edinburghScale.PostnatalDepressionScale.SelfHarmScore,
                            "edinburgh-score-width-18"
                        )}
                        {this.renderScore(
                            this.renderMultipleLabel(
                                "ObstetricalFile_AnxietySubscoreLabel",
                                null,
                                this.getLabelSuffix(
                                    `(${this.getString("ObstetricalFile_QuestionAbbrev3To5Label")}):`,
                                    "text-bold"
                                )
                            ),
                            edinburghScale.anxietySubScorePostnatalDepressionScore,
                            "edinburgh-score-width-18"
                        )}
                        {this.renderScore(
                            <span className="text-bold">
                                {this.getString("TotalScoreLabel")}
                            </span>,
                            edinburghScale.PostnatalDepressionScale.totalScore,
                            "edinburgh-score-width-12"
                        )}
                    </div>
                    <div className="padding-md-left padding-md-right">
                        {this.renderMultipleLabel(
                            "ObstetricalFile_TotalScoreGreater14Label",
                            null,
                            this.getLabelSuffix(
                                `${this.getString("ObstetricalFile_TotalScoreGreater14ExplainLabel")}`,
                                "text-normal"
                            )
                        )}
                        {this.renderMultipleLabel(
                            "ObstetricalFile_TotalScore12-13Label",
                            null,
                            this.getLabelSuffix(
                                `${this.getString("ObstetricalFile_MinorSupportOfferLabel")}`,
                                "text-normal"
                            )
                        )}
                        {this.renderMultipleLabel(
                            "ObstetricalFile_AnxietySubscoreQuestion3To5Greater6Label",
                            null,
                            this.getLabelSuffix(
                                `${this.getString("ObstetricalFile_MinorSupportOfferLabel")}`,
                                "text-normal"
                            ),
                            "padding-sm-top"
                        )}
                        {this.renderMultipleLabel(
                            "ObstetricalFile_SelfharmSubscoreQuestion10Score1To3Label",
                            null,
                            this.getLabelSuffix(
                                `${this.getString("ObstetricalFile_SelfharmSubscoreQuestion10Score1To3ExplainLabel")}`,
                                "text-normal"
                            ),
                            "padding-sm-top"
                        )}

                        <p className="text-bold text-italic padding-sm-top">
                            {this.getString("ObstetricalFile_EpdsShouldBeCompletedLabel")}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    private renderScore(label: React.ReactNode, value?: number, containerClassName?: string): JSX.Element {
        return (
            <div className={`inline-flex-center ${containerClassName ?? ""}`}>
                {label}
                <span className="text-bold margin-md-left margin-lg-right">
                    {value ?? ""}
                </span>
            </div>
        );
    }

    private shouldUpdateSection14(): boolean {
        const hasSameDay =
            !this.props.form.Section14.Date ||
            (
                !!this.props.form.Resources.PostnatalDepressionScale.PostnatalDepressionScaleDate &&
                LuxonDateTimeParser.parse(this.props.form.Section14.Date).hasSame(LuxonDateTimeParser.parse(this.props.form.Resources.PostnatalDepressionScale.PostnatalDepressionScaleDate), "day")
            );

        return this.props.form.Section14.EdinburghTotalScore == this.props.form.Resources.PostnatalDepressionScale.totalScore
            && this.props.form.Section14.AnxietySubScore == this.props.form.Resources.anxietySubScorePostnatalDepressionScore
            && this.props.form.Section14.SelfHarmSubScore == this.props.form.Resources.PostnatalDepressionScale.SelfHarmScore
            && hasSameDay;
    }

    private autoFillSection14(form: BritishColumbiaObstetricalFileForm): void {
        const edinburghDate = form.Resources.PostnatalDepressionScale.PostnatalDepressionScaleDate;
        form.Section14.Date = edinburghDate;
        form.Section14.EdinburghTotalScore = form.Resources.PostnatalDepressionScale.totalScore;
        form.Section14.AnxietySubScore = form.Resources.anxietySubScorePostnatalDepressionScore;
        form.Section14.SelfHarmSubScore = form.Resources.PostnatalDepressionScale.SelfHarmScore;

        if (edinburghDate)
            this.setGestationalAgeSection14(form);
    }
}

export { BritishColumbiaObstetricalFileResourcesEdinburghScale };
